import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import MarketingLayout from "@/components/marketing/MarketingLayout"
import { Button } from "@/components/ui/button"

export default function NotFound() {
  const { t } = useTranslation()

  return (
    <MarketingLayout seoKey="notFound">
      <div className="pt-40 pb-32 text-center px-6">
        <p className="text-xs tracking-[0.2em] uppercase font-semibold text-muted-foreground mb-4">404</p>
        <h1 className="font-display text-5xl tracking-tighter font-medium">{t("pages.notFound.title")}</h1>
        <p className="mt-4 text-muted-foreground max-w-md mx-auto">{t("pages.notFound.subtitle")}</p>
        <Link to="/" className="inline-block mt-8">
          <Button className="rounded-full">{t("pages.notFound.cta")}</Button>
        </Link>
      </div>
    </MarketingLayout>
  )
}
